import lodash from 'lodash'
import Base from '../base.store'
import moment from "moment";
import { filter } from "../../../../utils/search";
import { cacheTime } from "../../../../utils/constant";

const baseUrl = '/api/v1/transaction/company-countries'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listCompany: {},
        listCompanyCountry: {},
        cacheDate: {
            listCompany: {},
            listCompanyCountry: {},
        }
    }),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        searchByRefCompanyId(context, { criteria, config, searchQuery, refCompanyId, where = [] }) {
            const wheres = [
                { name: "isActive", type: "Boolean", operator: '=', value: true },
                { name: "refCompany.id", type: "UUID", operator: '=', value: refCompanyId },
                { name: "refStatus.key", type: "String", operator: '=', value: 'Approve' },
                ...where
            ]
            if (searchQuery) {
                wheres.push({ openBucket: true, name: "refCountry.nameTh", type: 'String', operator: 'like', value: searchQuery })
                wheres.push({ closeBucket: true, logic: 'OR', name: "refCountry.nameEn", type: 'String', operator: 'like', value: searchQuery })
            }
            criteria = lodash.merge({
                select: ['*', 'refCountry.*', 'refStatus.*'],
                page: 0,
                size: 100,
                sort: [{ name: "refCountry.nameTh", type: "ASC" }],
                where: wheres
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    return list
                });
        },
        cacheFindAllCountryByRefCompanyId(context, { refCompanyId, searchQuery, options, where = [] }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listCompany[refCompanyId];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const whereFilter = []

            if(searchQuery) {
                whereFilter.push(
                    { openBucket: true, name: "nameTh", type: 'String', operator: 'like', value: searchQuery },
                    { closeBucket: true, logic: 'OR', name: "nameEn", type: 'String', operator: 'like', value: searchQuery }
                )
            }

            const sort = [{ name: 'seq', type: 'asc' }, { name: 'refCompany.nameTh', type: 'ASC' }]
            const list = context.state.listCompany[refCompanyId] || []
            if (list.length > 0 && !force) {
                return filter({  list: list.map(d => d.refCountry), where: whereFilter, sort })
            }
            return context.dispatch('findAllCountryByRefCompanyId', { refCompanyId, ...where })
                .then(list => {
                    return filter({  list: list.map(d => d.refCountry), where: whereFilter, sort })
                })
        },
        cacheFindAllCompanyCountryByRefCompanyId(context, { refCompanyId, searchQuery, options, where = [] }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listCompanyCountry[refCompanyId];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const whereFilter = []

            if(searchQuery) {
                whereFilter.push(
                    { openBucket: true, name: "nameTh", type: 'String', operator: 'like', value: searchQuery },
                    { closeBucket: true, logic: 'OR', name: "nameEn", type: 'String', operator: 'like', value: searchQuery }
                )
            }

            const sort = [{ name: 'seq', type: 'asc' }, { name: 'refCompany.nameTh', type: 'ASC' }]
            const list = context.state.listCompanyCountry[refCompanyId] || []
            if (list.length > 0 && !force) {
                return filter({  list: list.map(d => d.refCountry), where: whereFilter, sort })
            }
            return context.dispatch('findAllCompanyCountryByRefCompanyId', { refCompanyId, ...where })
                .then(list => {
                    return filter({  list: list, where: whereFilter, sort })
                })
        },

        findAllCompanyCountryByRefCompanyId(context, { criteria, config, refCompanyId, where=[] }) {
            const wheres = [
                { name: "isActive", type: "Boolean", operator: '=', value: true },
                { name: "refCompany.id", type: "UUID", operator: '=', value: refCompanyId },
                { name: "refStatus.key", type: "String", operator: '=', value: 'Approve' },
                ...where
            ]
            criteria = lodash.merge({
                select: ['**'],
                page: 0,
                size: 1000000,
                sort: [{ name: "refCountry.nameTh", type: "ASC" }],
                where: wheres,
                children: [
                    { name: 'refCountry.children', select: ['*', 'refParent.*'], page: 0, size: 1000000 },
                ]
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    context.commit('setListCompanyCountryResult', { refCompanyId, list })
                    return list
                });
        },
        findAllCountryByRefCompanyId(context, { criteria, config, refCompanyId, where=[] }) {
            const wheres = [
                { name: "isActive", type: "Boolean", operator: '=', value: true },
                { name: "refCompany.id", type: "UUID", operator: '=', value: refCompanyId },
                { name: "refStatus.key", type: "String", operator: '=', value: 'Approve' },
                ...where
            ]
            criteria = lodash.merge({
                select: ['**'],
                page: 0,
                size: 1000000,
                sort: [{ name: "refCountry.nameTh", type: "ASC" }],
                where: wheres,
                children: [
                    { name: 'refCountry.children', select: ['*', 'refParent.*'], page: 0, size: 1000000 },
                ]
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    context.commit('setListCompanyResult', { refCompanyId, list })
                    return list
                });
        },
    },
    mutations: {
        setListCompanyResult(state, { refCompanyId, list }) {
            state.listCompany[refCompanyId] = list
            state.cacheDate.listCompany[refCompanyId] = moment().add(cacheTime, 'ms')
        },
        setListCompanyCountryResult(state, { refCompanyId, list }) {
            state.listCompanyCountry[refCompanyId] = list
            state.cacheDate.listCompanyCountry[refCompanyId] = moment().add(cacheTime, 'ms')
        },
    },
}
